/* eslint-disable */
(function (algolia) {
    "use strict";

    const { autocomplete, getAlgoliaResults } = window['@algolia/autocomplete-js'];
    const { createQuerySuggestionsPlugin } = window['@algolia/autocomplete-plugin-query-suggestions'];
    const { createInsightsMiddleware } = window.instantsearch.middlewares;

    algolia.externals = {
        // Export the required librarires
        instantsearch: window.instantsearch,
        algoliasearch: window.algoliasearch,
        autocomplete,
        getAlgoliaResults,
        createQuerySuggestionsPlugin,
        createInsightsMiddleware,
        html: window.htmPreact.html, //used by templates to display safe HTML
        render: window.htmPreact.render,
        useState: window.htmPreact.useState,
        useEffect: window.htmPreact.useEffect,
        useRef: window.htmPreact.useRef,
        useCallback: window.htmPreact.useCallback,

        // Export the required widgets
        widgets: {
            rangeSlider: window.instantsearch.widgets.rangeSlider,
            rangeInput: window.instantsearch.widgets.rangeInput,
            menu: window.instantsearch.widgets.menu,
            refinementList: window.instantsearch.widgets.refinementList,
            searchBox: window.instantsearch.widgets.searchBox,
            stats: window.instantsearch.widgets.stats,
            sortBy: window.instantsearch.widgets.sortBy,
            clearRefinements: window.instantsearch.widgets.clearRefinements,
            panel: window.instantsearch.widgets.panel,
            hits: window.instantsearch.widgets.hits,
            pagination: window.instantsearch.widgets.pagination,
            configure: window.instantsearch.widgets.configure,
            // Define any new widgets here...
            index: window.instantsearch.widgets.index,
            relatedProducts: window.instantsearch.widgets.relatedProducts,
            frequentlyBoughtTogether: window.instantsearch.widgets.frequentlyBoughtTogether,
            trendingItems: window.instantsearch.widgets.trendingItems
        },

        // Export InstantSearch connectors
        connectors: {
            connectCurrentRefinements: instantsearch.connectors.connectCurrentRefinements,
            connectHits: instantsearch.connectors.connectHits,
            connectFrequentlyBoughtTogether: instantsearch.connectors.connectFrequentlyBoughtTogether,
            connectRelatedProducts: instantsearch.connectors.connectRelatedProducts,
            connectTrendingItems: instantsearch.connectors.connectTrendingItems,
            connectSortBy: instantsearch.connectors.connectSortBy,
            connectRefinementList: instantsearch.connectors.connectRefinementList,
            connectRange: instantsearch.connectors.connectRange,
        },
    };
})(window.algoliaShopify);